import type { ViewState } from '#components/Root/viewModel'

import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import DateTimeRow from '../DateTimeRow'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomTimeInterval')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomTimeInterval = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph className={styles.title} variant='subtitle1'>
        {state.currentNode.text}
      </Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      <Paragraph className={styles.defaultWeight} variant='subtitle2'>
        {tp('begin')}
      </Paragraph>
      <br />
      <DateTimeRow
        dateFieldProps={{
          maxDate: viewModel.endTimestamp || viewModel.today,
          label: tp('date'),
          name: 'startdate',
        }}
        // @ts-expect-error@2339
        error={viewModel.error}
        onChange={viewModel.handleStartDateChange}
        timeFieldProps={{
          label: tp('time'),
          name: 'starttime',
        }}
        // @ts-expect-error@2322
        value={viewModel.startTimestamp}
      />
      <br />
      <Paragraph className={styles.defaultWeight} variant='subtitle2'>
        {tp('end')}
      </Paragraph>
      <br />
      <DateTimeRow
        dateFieldProps={{
          maxDate: viewModel.today,
          minDate: viewModel.startTimestamp,
          label: tp('date'),
          name: 'enddate',
        }}
        // @ts-expect-error@2339
        error={viewModel.error}
        onChange={viewModel.handleEndDateChange}
        onNowClick={viewModel.handleNowClick}
        timeFieldProps={{
          label: tp('time'),
          name: 'endtime',
        }}
        // @ts-expect-error@2322
        value={viewModel.endTimestamp}
      />
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomTimeInterval)
component.displayName = 'CustomTimeInterval'
export default component
